var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "properties-field", attrs: { id: _vm.id } }, [
    _c("div", { staticClass: "wrap-properties" }, [
      _c("div", { staticClass: "properties-field-title" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "close-properties",
            on: { click: _vm.closeConfiguration }
          },
          [_vm._v("\n        ×\n      ")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "wrap-type" }, [
          _c("img", {
            attrs: {
              src: require("@/assets/new-form-ui/icon/button.svg"),
              height: "32"
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "text-type" }, [_vm._v(_vm._s(_vm.label))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "properties-field-content" }, [
        _c(
          "div",
          { staticClass: "section-field input-field" },
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12" } },
                  [
                    _c(
                      "b-form",
                      {
                        class: { "error-input": _vm.$v.dataSetup.label.$error }
                      },
                      [
                        _c("div", { staticClass: "title-field" }, [
                          _c("label", [_vm._v(" Label ")])
                        ]),
                        _vm._v(" "),
                        _c("j-input", {
                          attrs: { placeholder: "Enter button label" },
                          model: {
                            value: _vm.dataSetup.label,
                            callback: function($$v) {
                              _vm.$set(_vm.dataSetup, "label", $$v)
                            },
                            expression: "dataSetup.label"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.isRevisionBtn
                  ? _c(
                      "b-col",
                      { attrs: { cols: "12" } },
                      [
                        _c(
                          "b-form",
                          {
                            class: {
                              "error-input":
                                _vm.$v.dataSetup.revision_method.$error
                            }
                          },
                          [
                            _c("div", { staticClass: "title-field" }, [
                              _c("label", [_vm._v(" Method ")])
                            ]),
                            _vm._v(" "),
                            _c("j-single-select", {
                              attrs: {
                                options: _vm.methodOptions,
                                placeholder: "Select Method",
                                label: "name"
                              },
                              model: {
                                value: _vm.dataSetup.revision_method,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.dataSetup,
                                    "revision_method",
                                    $$v
                                  )
                                },
                                expression: "dataSetup.revision_method"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "section-field input-field" }, [
          _c("h4", { staticClass: "title-section" }, [_vm._v("Configuration")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "configuration-section" },
            [
              _c("b-form", [
                _c(
                  "div",
                  { staticClass: "configuration-toggle-in-title" },
                  [
                    _c("div", { staticClass: "wrap-title" }, [
                      _c("h4", { staticClass: "configuration-section-title" }, [
                        _vm._v("Hidden")
                      ]),
                      _vm._v(" "),
                      _c(
                        "p",
                        { staticClass: "configuration-section-desc m-0" },
                        [
                          _vm._v(
                            "\n                  The button is invisible, but still affect layout as normal.\n                "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("j-switch", {
                      model: {
                        value: _vm.dataSetup.is_hidden,
                        callback: function($$v) {
                          _vm.$set(_vm.dataSetup, "is_hidden", $$v)
                        },
                        expression: "dataSetup.is_hidden"
                      }
                    })
                  ],
                  1
                )
              ])
            ],
            1
          )
        ]),
        _vm._v(" "),
        !_vm.isRevisionBtn
          ? _c("div", { staticClass: "section-field input-field" }, [
              _c("h4", { staticClass: "title-section" }, [
                _vm._v("Custom Actions")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "configuration-section" }, [
                _c("div", { staticClass: "div-custom-action" }, [
                  _c("div", { staticClass: "wrap-left" }, [
                    _c("img", {
                      staticClass: "icon",
                      attrs: {
                        src: require("@/assets/new-form-ui/icon/script-action.svg")
                      }
                    }),
                    _vm._v(" "),
                    _c("div", [
                      _c("p", { staticClass: "title-div" }, [
                        _vm._v(
                          "\n                  Before Action\n                  "
                        ),
                        _vm.dataSetup.script_before ||
                        _vm.dataSetup.container_script_before_is_not_valid ||
                        _vm.dataSetup
                          .container_script_before_is_not_valid_message
                          ? _c("img", {
                              attrs: {
                                src: require("@/assets/new-form-ui/icon-active/check-circle-active.svg")
                              }
                            })
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _vm._m(1)
                    ])
                  ]),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "open-modal",
                    attrs: { src: require("@/assets/new-form-ui/setup.svg") },
                    on: { click: _vm.openModalScriptBefore }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "configuration-section" }, [
                _c("div", { staticClass: "div-custom-action" }, [
                  _c("div", { staticClass: "wrap-left" }, [
                    _c("img", {
                      staticClass: "icon",
                      attrs: {
                        src: require("@/assets/new-form-ui/icon/script-action.svg")
                      }
                    }),
                    _vm._v(" "),
                    _c("div", [
                      _c("p", { staticClass: "title-div" }, [
                        _vm._v(
                          "\n                  After Action\n                  "
                        ),
                        _vm.dataSetup.script ||
                        _vm.dataSetup.variable_message ||
                        _vm.dataSetup.variable_redirect
                          ? _c("img", {
                              attrs: {
                                src: require("@/assets/new-form-ui/icon-active/check-circle-active.svg")
                              }
                            })
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _vm._m(2)
                    ])
                  ]),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "open-modal",
                    attrs: { src: require("@/assets/new-form-ui/setup.svg") },
                    on: { click: _vm.openModalScriptAfter }
                  })
                ])
              ]),
              _vm._v(" "),
              _vm.dataSetup.container_params || _vm.dataSetup.container_record
                ? _c(
                    "div",
                    { staticClass: "configuration-section" },
                    [
                      _c(
                        "p",
                        { staticClass: "configuration-section-title mb-2" },
                        [_vm._v("Other Variable")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { staticClass: "mb-2", attrs: { cols: "12" } },
                            [
                              _c("div", { staticClass: "title-field" }, [
                                _c("label", [_vm._v(" Variable Params ")])
                              ]),
                              _vm._v(" "),
                              _c("j-input", {
                                attrs: {
                                  "error-required": false,
                                  disabled: true
                                },
                                model: {
                                  value: _vm.dataSetup.container_params,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.dataSetup,
                                      "container_params",
                                      $$v
                                    )
                                  },
                                  expression: "dataSetup.container_params"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("div", { staticClass: "title-field" }, [
                                _c("label", [_vm._v(" Variable Record ")])
                              ]),
                              _vm._v(" "),
                              _c("j-input", {
                                attrs: {
                                  "error-required": false,
                                  disabled: true
                                },
                                model: {
                                  value: _vm.dataSetup.container_record,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.dataSetup,
                                      "container_record",
                                      $$v
                                    )
                                  },
                                  expression: "dataSetup.container_record"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.mode === "approve" || _vm.mode === "approveUpdate"
                ? _c(
                    "div",
                    { staticClass: "configuration-section" },
                    [
                      _c("b-form", [
                        _c(
                          "div",
                          { staticClass: "configuration-toggle-in-title" },
                          [
                            _c("div", { staticClass: "wrap-title" }, [
                              _c(
                                "h4",
                                { staticClass: "configuration-section-title" },
                                [_vm._v("Mandatory Note")]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticClass: "configuration-section-desc m-0"
                                },
                                [
                                  _vm._v(
                                    "\n                  Note before action will be mandatory\n                "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("j-switch", {
                              model: {
                                value:
                                  _vm.dataSetup.config_dialog_message
                                    .is_note_mandatory,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.dataSetup.config_dialog_message,
                                    "is_note_mandatory",
                                    $$v
                                  )
                                },
                                expression:
                                  "dataSetup.config_dialog_message.is_note_mandatory"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                : _vm._e()
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "properties-field-button" }, [
        _c(
          "button",
          {
            staticClass: "button-border",
            on: { click: _vm.resetConfiguration }
          },
          [
            _c("img", {
              attrs: { src: require("@/assets/new-form-ui/icon/reset.svg") }
            }),
            _vm._v("\n        Reset\n      ")
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex align-items-center" }, [
          _c(
            "button",
            {
              staticClass: "button-border mr-2",
              on: { click: _vm.closeConfiguration }
            },
            [_vm._v("\n          Close\n        ")]
          ),
          _vm._v(" "),
          _c(
            "button",
            { staticClass: "button-blue", on: { click: _vm.submitForm } },
            [_vm._v("\n          Apply\n        ")]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", { staticClass: "title" }, [
      _vm._v("\n        Properties\n        "),
      _c("div", { staticClass: "title-badge" }, [_vm._v("Button")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "desc-div" }, [
      _vm._v("\n                  Actions to be executed "),
      _c("b", [_vm._v("before")]),
      _vm._v(" the main process (CRUD) is executed.\n                ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "desc-div" }, [
      _vm._v("\n                  Actions to be executed "),
      _c("b", [_vm._v("after")]),
      _vm._v(" the main process (CRUD) is executed.\n                ")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-125704be", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-125704be","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/experience-manager-v2/partials/configuration/NativeButtonConfiguration.vue
// module id = null
// module chunks = 